import React from 'react';

const Success = ({ title, content, buttonUrl, buttonLabel }) => {
  return (
    <div className='text-center'>
      <div className='text-2xl'>{title}</div>
      <div>
        <p className='text-lg'>{content}</p>
        <div className='block border-b border-gray-300 mt-4 mb-8' />
        <a
          href={buttonUrl}
          className='px-4 py-2 inline-block bg-orange-500 text-white rounded text-sm'
        >
          {buttonLabel}
        </a>
      </div>
    </div>
  );
};

export default Success;
